import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";

function Cookies() {
  return (
    <div className="privacy legal-page">
      <Header />
      <main id="MainContent">
        <article id="cms-content" aria-labelledby="cookies-title">
          <div>
            <p className="legal-page__eyebrow">Legal &amp; privacy</p>
            <h1 id="cookies-title">Cookie Policy</h1>
            <p className="legal-page__updated">
              <strong>Last updated: October 16, 2026</strong>
            </p>
            <p className="legal-page__intro">
              This policy explains how averlynxstore may use cookies, browser
              storage, pixels, tags, and similar technologies on its website.
              It should be read with our <Link to="/privacy">Privacy Policy</Link>.
            </p>

            <section className="legal-page__section">
              <h2>1. What these technologies are</h2>
              <p>
                Cookies are small text files stored by a browser. Local storage
                saves information on a device in a similar way. Pixels and tags
                are small pieces of code that can record when a page, message,
                or feature is viewed or used. We refer to these technologies
                together as &quot;cookies&quot; in this policy.
              </p>
            </section>

            <section className="legal-page__section">
              <h2>2. Cookie categories</h2>
              <table>
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Typical purpose</th>
                    <th>Choice</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Strictly necessary</td>
                    <td>
                      Security, network management, cart, checkout, fraud
                      prevention, requested preferences, and other functions
                      needed to provide the service.
                    </td>
                    <td>
                      Cannot usually be disabled through a consent tool because
                      the requested service may not work without them.
                    </td>
                  </tr>
                  <tr>
                    <td>Functional</td>
                    <td>
                      Remember language, region, display, and other enhanced
                      preferences.
                    </td>
                    <td>May be optional depending on purpose and location.</td>
                  </tr>
                  <tr>
                    <td>Analytics</td>
                    <td>
                      Understand visits, navigation, errors, feature use, and
                      aggregated performance so the store can be improved.
                    </td>
                    <td>Used with consent when applicable law requires it.</td>
                  </tr>
                  <tr>
                    <td>Advertising</td>
                    <td>
                      Measure campaigns, limit repetition, or personalize
                      advertising when these features are enabled.
                    </td>
                    <td>Optional and consent-based where required.</td>
                  </tr>
                </tbody>
              </table>
            </section>

            <section className="legal-page__section">
              <h2>3. First- and third-party cookies</h2>
              <p>
                First-party cookies are set for the averlynxstore website.
                Third-party cookies or similar requests may be controlled by a
                provider used for payment, security, hosting, analytics,
                communications, embedded media, or advertising. A third party
                may process data under its own privacy notice when it acts
                independently.
              </p>
            </section>

            <section className="legal-page__section">
              <h2>4. Duration</h2>
              <p>
                Session cookies normally expire when the browser closes.
                Persistent cookies remain until their configured expiration,
                deletion, or replacement. The exact duration depends on the
                purpose and provider and may change when services are updated.
                We aim to use a duration proportionate to the stated purpose.
              </p>
            </section>

            <section className="legal-page__section">
              <h2>5. Your controls</h2>
              <ul>
                <li>
                  Use any cookie preference control presented on the website to
                  accept, reject, or update optional categories.
                </li>
                <li>
                  Use browser settings to view, block, or delete cookies and
                  site data. Blocking necessary storage may prevent the cart,
                  checkout, sign-in, or preferences from working correctly.
                </li>
                <li>
                  Adjust device, operating-system, or advertising-platform
                  settings where they apply.
                </li>
                <li>
                  Contact us if you need help identifying a privacy choice.
                </li>
              </ul>
              <p>
                Withdrawing consent does not make earlier consent-based use
                unlawful, but it should stop future optional use after the
                preference is processed.
              </p>
            </section>

            <section className="legal-page__section">
              <h2>6. Browser privacy signals</h2>
              <p>
                Where applicable law requires recognition of a supported
                browser-based opt-out signal, we process it for the browser or
                device from which it is received. Because signal standards and
                legal requirements vary, the effect may depend on location,
                browser, and the technologies active on the site.
              </p>
            </section>

            <section className="legal-page__section">
              <h2>7. Changes to cookie use</h2>
              <p>
                Providers and technologies may change as the store changes. We
                will update this policy and any preference interface when
                required. A material new optional purpose will be presented for
                consent where applicable law requires it.
              </p>
            </section>

            <section className="legal-page__section">
              <h2>8. Contact</h2>
              <p>
                Questions about cookies or privacy choices may be sent to{" "}
                <a href="mailto:cost@averlynxstore.one">
                  cost@averlynxstore.one
                </a>
                . You can also review the{" "}
                <Link to="/policies/regional-privacy">
                  Regional Privacy Rights &amp; Requests
                </Link>{" "}
                page.
              </p>
            </section>

            <aside className="legal-page__notice">
              The technologies actually active on a visit depend on store
              configuration, region, consent status, browser settings, and the
              features you use.
            </aside>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}

export default Cookies;
